import windowLocalStorage from "../utils/localStorage";

export function getFromEnvVarsOrLocalStorage(str) {
  return process.env[str] || windowLocalStorage?.getItem(str);
}

// feature flags used to enable work-in-progress features
// local storage is helpful to allow testing in production
// without having to redeploy or enable the feature for everyone
// the option to enable for the whole node is still available, but should be used sparingly

// example usage:
// export const featuredImageAltFormField = getFromEnvVarsOrLocalStorage("REACT_APP_FF_FEATURED_IMG_ALT");
